// Delete removes your private copy; unshare takes the public record down for
// everyone and is a moderator's call.
export const DELETE_LABEL = 'Delete';
export const UNSHARE_LABEL = 'Unshare';
